import { TreeNode } from "../models/interfaces/tree-node.interface"


export const createParent = (id: string, name?: string, isChechkable: boolean = true) =>
    <TreeNode>{
        id: id,
        name: name,
        showChildren: false,
        isParent: true,
        isChecked: false,
        isCheckable: isChechkable,
        children: []
    }


export const createChild = (
    parent: TreeNode | undefined,
    idsEntity: string[] | undefined,
    id: string, name: string,
    isChechkable: boolean = true) => {

    let isChecked = false

    if (idsEntity) {
        isChecked = idsEntity.includes(id) ? true : false
    }

    return <TreeNode>{
        id: id,
        parent: parent,
        name: name,
        isParent: false,
        isChecked: isChecked,
        isCheckable: isChechkable,
        showChildren: false,
        children: []
    }
}

